import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DynamicMenu from './DynamicMenu';

// Right Click - Context Menu
function ConnectedDynamicMenuWrapper({ content = [], options = null, dimension, isAutomix }) {
  const { playerCoordinates, fullHeight } = dimension;

  const onHide = () => {
    if (playerCoordinates && fullHeight && !isAutomix) {
      if (document.getElementById(playerCoordinates.playerID)) {
        document.getElementById(playerCoordinates.playerID).style[`z-index`] = 80;
      }
    }
  }

  const onShow = () => {
    if (playerCoordinates && fullHeight && !isAutomix) {
      if (document.getElementById(playerCoordinates.playerID)) {
        document.getElementById(playerCoordinates.playerID).style[`z-index`] = 5;
      }
    }
  }

  return (
    <DynamicMenu content={content} options={options} onHide={onHide} onShow={onShow} />
  )
}

ConnectedDynamicMenuWrapper.propTypes = {
  content: PropTypes.array,
  options: PropTypes.any
}

const DynamicMenuWrapper = connect(
  state => ({
    content: state.contextMenu,
    options: state.contextMenuOptions,
    dimension: state.dimension,
    isAutomix: !!state.uidAutomix,
  })
)(ConnectedDynamicMenuWrapper);

export default DynamicMenuWrapper;
